/**
 * Preparação Web Push (FASE-05-T17 → FASE-09-T04).
 * Requer VITE_VAPID_PUBLIC_KEY e service worker ativo.
 */

const SUB_KEY = "evolua.pwa.push-subscription";

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function getStoredPushSubscription(): PushSubscriptionJSON | null {
  try {
    const raw = localStorage.getItem(SUB_KEY);
    return raw ? (JSON.parse(raw) as PushSubscriptionJSON) : null;
  } catch {
    return null;
  }
}

export async function registerPushSubscription(): Promise<PushSubscriptionJSON> {
  const vapid = import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined;
  if (!vapid) {
    throw new Error("VITE_VAPID_PUBLIC_KEY não configurada");
  }
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("Push não suportado neste navegador");
  }

  const reg = await navigator.serviceWorker.ready;
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Permissão de notificação negada");
  }

  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapid) as BufferSource,
  });
  const json = sub.toJSON();
  localStorage.setItem(SUB_KEY, JSON.stringify(json));

  const apiBase = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(
    /\/$/,
    "",
  );
  if (apiBase) {
    try {
      await fetch(`${apiBase}/v1/push/subscriptions`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ subscription: json }),
      });
    } catch {
      // API opcional nesta fase — assinatura local já valida o fluxo do browser.
    }
  }

  return json;
}
